import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import investStock from "./investStock";
import NormalGameManager from "../../manager/NormalGameManager";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../BundleResourceConfig";
import { GeneralKind } from "../../../define/GeneralKind";
import utilsModel from "../../../../engines/libs/utilsModel";

const {ccclass, property} = cc._decorator;

@ccclass
export default class selectPriceNode extends cc.Component {

    @property({type:cc.Label,displayName:"价格文本"})
    lb_Price:cc.Label = null;

    @property({type:cc.Label,displayName:"库存文本"})
    inventoryLb:cc.Label = null;

    @property({type:cc.Label,displayName:"需要的钱的文本"})
    needCoinLb:cc.Label = null;

    @property({type:cc.Label,displayName:"数量文本"})
    lb_Count:cc.Label = null;

    @property({type:cc.RichText,displayName:"消耗文本"})
    lbSub:cc.Label = null;

    @property({type:cc.Node,displayName:"购买的视频图标"})
    videoNode:cc.Node = null;

    @property({type:cc.Sprite,displayName:""})
    icon:cc.Sprite = null;

    currentCount:number = 0;

    investStock:investStock = null;

    maxCount:number = 0;

    complete:(moneyNum:number)=>void

    onEnable(){
        this.currentCount = 0;
        this.updatePriceLb();
    }

    bindData(investStock:investStock,complete?:(moneyNum:number)=>void,maxCount:number = 0){
        this.investStock = investStock ? investStock : this.investStock;
        this.maxCount = maxCount;
        this.complete = complete;
        this.loadIcon();
    }

    onBtnAddMoney(e:cc.Event.EventTouch,custom:string){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if ( O1HD.getServices().userSrv.getCoins() == 0 ) {
            NormalGameManager._instance.openBankPage().then();
            O1HD.getModules().uiControlModule.showMessageBox("您的资金不足");
            return;
        }
        switch(custom){
            case "0":{
                if(this.currentCount < 500){
                    this.currentCount = 0;
                }else{
                    this.currentCount -= 500;
                }
                break;
            }
            case "1":{
                if(this.currentCount < 100){
                    this.currentCount = 0;
                }else{
                    this.currentCount -= 100;
                }
                break;
            }
            case "2":{
                let canCount:number = 100;
                if(canCount + this.currentCount > this.maxCount){
                    canCount = this.maxCount - this.currentCount;
                }
                let oneCopyMoney:number = this.investStock.oneCopyMoney;
                let needCoin = (canCount + this.currentCount) * oneCopyMoney;

                let coin = O1HD.getServices().userSrv.getCoins();
                if( coin < needCoin){
                    this.currentCount = Math.floor(coin / oneCopyMoney);
                }else{
                    this.currentCount += canCount;
                }
                break;
            }
            case "3":{
                let canCount:number = 500;
                if(canCount + this.currentCount > this.maxCount){
                    canCount = this.maxCount - this.currentCount;
                }
                let oneCopyMoney:number = this.investStock.oneCopyMoney;
                let needCoin = (canCount + this.currentCount) * oneCopyMoney;

                let coin = O1HD.getServices().userSrv.getCoins();
                if( coin < needCoin){
                    this.currentCount = Math.floor(coin / oneCopyMoney);
                }else{
                    this.currentCount += canCount;
                }
                break;
            }
        }
        this.updatePriceLb();
    }

    updatePriceLb(){
        this.lb_Price.string = data_control.getNumberFormat(this.investStock.oneCopyMoney);
        this.lb_Count.string = data_control.getNumberFormat(this.currentCount);
        this.needCoinLb.string = data_control.getNumberFormat(this.currentCount * this.investStock.oneCopyMoney);
        this.inventoryLb.string = data_control.getNumberFormat(this.maxCount - this.currentCount);
        let num = NormalGameManager._instance.getOneGood(GeneralKind.PropId.WATER_TRANSPORT_CARD_ID)?.num || 0;
        let color = num >0 ? "#4b9836" : "#FF0000";
        this.videoNode.active = num <= 0;
        this.lbSub.string = `<color = #51698A>需消耗</c><color = ${color}>${num}/1</c><color = #51698A>张漕运单</c>`
    }

    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.closeThis();
    }

    onBtnComit(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if(this.currentCount <= 0){
            O1HD.getModules().uiControlModule.showMessageBox("请选择加仓数额");
            return;
        }

        let completeFun = ()=>{
            let oneCopyMoney = this.investStock.oneCopyMoney;
            O1HD.getServices().userSrv.setCoins(-this.currentCount * oneCopyMoney,true);
            O1HD.getModules().uiControlModule.showMessageBox("购买成功");
            this.complete && this.complete(this.currentCount);
            this.closeThis();
        }

        let num = NormalGameManager._instance.getOneGood(GeneralKind.PropId.WATER_TRANSPORT_CARD_ID)?.num || 0;
        if(num <= 0){
            utilsModel.loadAndShowVideoAdTrans(()=>{
                completeFun();
            },()=>{

            },null,"看广告加仓");
        }else{
            NormalGameManager._instance.onOutGoods(GeneralKind.PropId.WATER_TRANSPORT_CARD_ID,1);
            completeFun();
        }
    }

    closeThis(){
        this.currentCount = 0;
        this.node.active = false;
    }

    loadIcon(){
        if(this.investStock.currentSelectItem){
            let spPath = this.investStock.currentSelectItem.icon;
            let bundle = getOneBundleByInstant(BUNDLE_SMALL_NAME.investStockGameBundle);
            bundle.load(`assets/obj/${spPath}`,cc.SpriteFrame,(err,asset:cc.SpriteFrame)=>{
                if(err){
                    console.debug("加载物品图片失败");
                    return;
                }
                this.icon.spriteFrame = asset;
            });
        }
    }

}
